import React, { useState, useEffect } from "react";

import {
  Modal,
  ModalBody,
  Button,
  Input,
  ModalHeader,
  Label,
  ModalFooter,
  Alert,
  Row,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { snapToQuarterHour } from "../../../../utils/dateUtils";
import { normalizeSingleLine } from "../../../../utils/normalizeText";
import * as actionCreators from "../../../../modules/actions/index";
import Loading from "../../../../hoc/Loading/Loading";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdFileUpload, MdOutlineMobileFriendly } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import Select from "react-select";
import { SURVEY_QUESTIONS } from "../../../../components/Survey/data";
// BiInfoCircle, TbMessageOff and FiMessageSquare belong to the One-way/Two-way
// control; the three Hi icons are the MESSAGE_MODES cards below.
import { BiMailSend, BiTrashAlt, BiX, BiInfoCircle } from "react-icons/bi";
import { TbMessageOff } from "react-icons/tb";
import { FiMessageSquare } from "react-icons/fi";
import {
  HiOutlineLightBulb,
  HiOutlinePencil,
  HiOutlineSparkles,
} from "react-icons/hi";
import { BsThreeDots } from "react-icons/bs";
import {
  isUrlValid,
  profilePicValidityCheck,
  trivvyFileTypeCheck,
  uploadPreview,
  MESSAGING_CONTENT_PLACEHOLDER,
} from "../../../../utils/constants";
import { toastContainer } from "../../../../utils/toast";
import {
  CREATE_LANGUAGE_OPTIONS_LIST,
  CREATE_LANGUAGE_SELECT_LABEL,
  CREATE_LANGUAGE_AUTO_DETECT_LABEL,
  CREATE_LANGUAGE_AUTO_DETECT_TOOLTIP,
  LANGUAGE_UNSET_VALUE,
  DUPLICATE_LANGUAGE_PLACEHOLDER,
  minPlanLimitCheck,
  SAMPLE_MESSAGING,
} from "../../data";
import VisibilitySelect from "../VisibilitySelect";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
import ReactDatePicker from "react-datepicker";
import CheckBox from "rc-checkbox";
import ReactTooltip from "react-tooltip";
import ShareHandlingForMessagingTrivvys from "./ShareHandlingForMessagingTrivvys";
import MessageAttachmentPicker from "../MessageAttachmentPicker";
import Accordion from "../../../../components/AccordionCommon/Accordion";
import UpgradeTag from "../../../../components/UpgradeTag";
import BwaiPromptList from "./BwaiPromptList";
import {
  BWAI_MSG_AI_BADGE,
  BWAI_MSG_AI_DESC,
  BWAI_MSG_AI_DRAFT_HINT,
  BWAI_MSG_AI_GENERATE,
  BWAI_MSG_AI_GENERATING,
  BWAI_MSG_AI_TITLE,
  BWAI_MSG_AI_UPDATE,
  BWAI_MSG_CONTENT_HINT,
  BWAI_MSG_CONTENT_LABEL,
  BWAI_MSG_MODE_AI,
  BWAI_MSG_MODE_AI_BADGE,
  BWAI_MSG_MODE_SAMPLE,
  BWAI_MSG_MODE_WRITE,
  BWAI_MSG_SAMPLE_CHOOSE_ANOTHER,
  BWAI_MSG_SAMPLE_HEADING,
  BWAI_MSG_SAMPLE_SELECTED,
  BWAI_MSG_START_LABEL,
  BWAI_PICKER_CANCEL,
  BWAI_SAMPLE_MESSAGE_ACTION,
} from "./createTriviaCopy";

const MESSAGE_MODES = [
  {
    key: "AI",
    Icon: HiOutlineSparkles,
    label: BWAI_MSG_MODE_AI,
    badge: BWAI_MSG_MODE_AI_BADGE,
  },
  { key: "SAMPLE", Icon: HiOutlineLightBulb, label: BWAI_MSG_MODE_SAMPLE },
  { key: "WRITE", Icon: HiOutlinePencil, label: BWAI_MSG_MODE_WRITE },
];

const questionOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

function CreateTriviaPopup({
  open,
  onClose,
  onAddSuccess,
  generateFromLibrary,
  preSelectedData,
  resourceId,
  incrementTrivCount,
  generateNewLibDocfromTools,
  user,
  onBack,
  uiType = "POPUP",
  autoSelectedTrivvyType = "CUSTOM",
  onTrivvyMultiGenerate,
  isMessaging,
  ...props
}) {
  // TBV-671: admin-view privacy for this Message. Default "Only Me".
  const [visibility, setVisibility] = useState("ONLY_ME");
  const [formData, setFormData] = useState({
    name: "",
    fileUrl: "",
    uploadType: 1,
    uploadText: "",
    triviaType: 2,
    libraryId: null,
    questionsCount: null,
    trivvyParts: [],
    noOfTrivvys: 0,
  });

  const [isTitleManuallyTyped, setIsTitleManuallyTyped] = useState(false);
  const [errorsArr, setErrorsArr] = useState([]);
  const [currentFilters, setCurrentFilters] = useState("");
  const [scheduledDate, setScheduledDate] = useState(null);
  // Optional Message file: { attachment, attachmentUploadHandle } from the upload API.
  const [messageAttachment, setMessageAttachment] = useState(null);
  const [isUploadingAttachment, setIsUploadingAttachment] = useState(false);
  const [deletedIds, setDeletedIds] = useState([]);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [trivvyEndDate, setTrivvyEndDate] = useState(null);
  const [allowAttempts, setAllowAttempts] = useState(0);
  const [numberOfAttempts, setNumberOfAttempts] = useState(1);
  const [randomizeQuestions, setRandomizeQuestions] = useState(false);
  const [messagingSubject, setMessagingSubject] = useState("");
  const [messagingTitle, setMessagingTitle] = useState("");
  // Message type: false = Two-way (default), true = One-way. Sent to the
  // createAndSendIsMessageTypeTrivvy API, which already persists isOneWay.
  const [isOneWay, setIsOneWay] = useState(false);
  const [smsUsers, setSmsUsers] = useState([]);
  const [
    notifyAdminWhenUserRepliesToMessages,
    setNotifyAdminWhenUserRepliesToMessages,
  ] = useState(false);
  // "Generate with AI" is the recommended default. Only one mode's section is
  // mounted at a time, which is what keeps the modal off the scrollbar.
  const [messageMode, setMessageMode] = useState("AI");
  // Tracked per mode, not globally: a sample picked earlier must not reveal the
  // box under "Generate with AI", which opens it only once a draft comes back.
  const [hasGeneratedMessage, setHasGeneratedMessage] = useState(false);
  // Per-mode drafts: messagingSubject is one field, so without stashing it the
  // last mode to write overwrote the others while their UI claimed ownership.
  const [modeDrafts, setModeDrafts] = useState({
    AI: { subject: "", title: "" },
    SAMPLE: { subject: "", title: "" },
    WRITE: { subject: "", title: "" },
  });
  // Names the picked sample so the grid can collapse to a one-line summary.
  const [selectedSampleTitle, setSelectedSampleTitle] = useState(null);
  // Reopening the grid is a separate flag, not clearing the title above, so
  // Cancel can put the summary back with the original choice intact.
  const [isChoosingSample, setIsChoosingSample] = useState(false);
  const [aiWordingPrompt, setAiWordingPrompt] = useState("");
  const [isGeneratingWording, setIsGeneratingWording] = useState(false);

  const currentPaymentPlan =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType;

  const isEnterprisePlan = minPlanLimitCheck(currentPaymentPlan, "004");

  // Same gate and control as the Survey create modal. On a Message the admin
  // writes the body, so the pick states what they wrote rather than asking for
  // a translation -- it replaces detection instead of running after it.
  const showLanguageFeature = minPlanLimitCheck(currentPaymentPlan, "003");
  const [targetLanguage, setTargetLanguage] = useState(LANGUAGE_UNSET_VALUE);

  const createSurvey = () => {
    const payload = {
      randomizeQuestions,
      organizationName: user.profile.organizationId.name,
      name: formData.name,
      questionsCount: formData.questionsCount,
      generateFromLibrary: generateFromLibrary ? true : false,
      triviaType: formData.triviaType,
      trivvyEndDate: trivvyEndDate,
      allowAttempts,
      numberOfAttempts: allowAttempts == 1 ? numberOfAttempts : null,
      isMessaging,
      numberOfAttempts: null,
      messagingSubject: messagingSubject,
      // Only when the picker was shown -- see DuplicateTriviaPopup.
      ...(showLanguageFeature ? { targetLanguage: targetLanguage } : {}),
      smsUsers: smsUsers,
      notifyAdminWhenUserRepliesToMessages,
      adminVisibility: visibility,
    };

    const triviaForm = new FormData();
    triviaForm.append("payload", JSON.stringify(payload));

    if (formData.triviaType == 2) {
      setLoading(true);
      axios
        .post(url.createTrivia, triviaForm)
        .then(({ data }) => {
          onAddSuccess(data.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log("errr", err);
        });
    }
  };

  const createAndSendSMSSurvey = () => {
    const users_share = smsUsers.map((itm) => {
      const user = itm;
      const mediums = [];

      if (user.mobileNumber) {
        mediums.push("SMS");
      }

      if (user) {
        return {
          createDate: new Date(),
          status: "ACTIVE",
          smsDate: new Date(),
          firstName: user.firstName,
          lastName: user.lastName,
          userId: user.value,
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length > mediums.length
              ? itm.shareMediums
              : mediums,
        };
      } else {
        return {
          userId: itm.value,
          firstName: itm.label,
          lastName: "",
          date: itm.date ? itm.date : new Date(),
        };
      }
    });

    const getNameFormatted = () => {
          const candidates = [
            formData.name,
            messagingTitle,
            messagingSubject ? (messagingSubject.length > 10 ? `${messagingSubject.slice(0, 10)}...` : messagingSubject) : null,
            "Text survey"
          ];
      return candidates.find(Boolean);
    };

    const payload = {
      notifyAdminWhenUserRepliesToMessages,
      isMessaging: true,
      organizationName: user.profile.organizationId.name,
      name: normalizeSingleLine(getNameFormatted()),
      questionsCount: 0,
      generateFromLibrary: false,
      triviaType: formData.triviaType,
      trivvyEndDate: trivvyEndDate,
      allowAttempts: 0,
      numberOfAttempts: numberOfAttempts,
      messagingSubject: messagingSubject,
      isOneWay: isOneWay,
      // Only when the picker was shown -- see DuplicateTriviaPopup.
      ...(showLanguageFeature ? { targetLanguage: targetLanguage } : {}),
      scheduledDate: scheduledDate,
      filters: currentFilters,
      deletedUserIds: deletedIds,
      skipUsers: true,
      adminVisibility: visibility,
      ...(messageAttachment
        ? { attachmentUploadHandle: messageAttachment.attachmentUploadHandle }
        : {}),
    };

    if (formData.triviaType == 2) {
      // bug895: without this, the button stayed clickable through the whole
      // request and repeated clicks created multiple Messages.
      setLoading(true);
      axios
        .post(url.createAndSendIsMessageTypeTrivvy, payload)
        .then(({ data }) => {
          toastContainer(`Messaging Trivvy Created Successfully`, "success");
          onAddSuccess(data.data);
        })
        .catch((error) => {
          setLoading(false);
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message
          ) {
            toastContainer(error.response.data.errors.message, "error");
          }
        });
    }
  };

  // Stash what the outgoing mode had, restore what the incoming mode left.
  const switchMessageMode = (nextMode) => {
    if (nextMode === messageMode) {
      return;
    }
    const outgoing = messageMode;
    const restored = modeDrafts[nextMode];

    setModeDrafts((prev) => {
      return {
        ...prev,
        [outgoing]: { subject: messagingSubject, title: messagingTitle },
      };
    });
    setMessagingSubject(restored.subject);
    setMessagingTitle(restored.title);
    setIsChoosingSample(false);
    setMessageMode(nextMode);
  };

  // Each mode decides for itself whether there is anything to review, so the
  // box never leaks across from a sample into the AI flow.
  const showMessageContent =
    messageMode === "WRITE" ||
    (messageMode === "SAMPLE" && selectedSampleTitle) ||
    (messageMode === "AI" && hasGeneratedMessage);

  const generateWordingForMessage = () => {
    const promptText = aiWordingPrompt.trim();

    setIsGeneratingWording(true);

    axios
      .post(url.generateMessageWording, { prompt: promptText })
      .then(({ data }) => {
        setIsGeneratingWording(false);

        const wording =
          data && data.data && data.data.messageWording
            ? data.data.messageWording
            : "";

        const generatedTitle =
          data && data.data && data.data.messageTitle
            ? data.data.messageTitle
            : "";

        if (wording) {
          setMessagingSubject(wording.slice(0, 1500));
          setHasGeneratedMessage(true);

          // The title is PREPENDED to every outgoing SMS, and when it is blank
          // the send falls back to the first 10 characters of the body plus an
          // ellipsis — so the recipient reads a truncated fragment immediately
          // above the full message. Fill it the same way the Sample Messages
          // card does, and leave a title the admin typed themselves alone.
          if (generatedTitle) {
            setMessagingTitle(generatedTitle);
            if (!isTitleManuallyTyped) {
              // Functional form: `formData` was captured when Generate was
              // clicked, so spreading it directly would revert any other field
              // changed while the request was in flight.
              setFormData((prev) => {
                return { ...prev, name: generatedTitle };
              });
            }
          }
        } else {
          toastContainer(
            "We could not generate message wording. Please try again.",
            "error"
          );
        }
      })
      .catch((error) => {
        setIsGeneratingWording(false);

        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message
        ) {
          toastContainer(error.response.data.errors.message, "error");
        } else {
          toastContainer(
            "We could not generate message wording. Please try again.",
            "error"
          );
        }
      });
  };

  const isValidResponses = () => {
    let errors = [];
    let bool = true;
    if (isMessaging) {
      if (!messagingSubject) {
        errors.push("Please enter subject");
        bool = false;
      }
      // if (!smsUsers.length) {
      //   bool = false
      //   errors.push('Please add users')
      // }
    } else {
      if (!formData.name) {
        bool = false;
        errors.push("Please enter Name");
      }

      if (!formData.questionsCount) {
        bool = false;
        errors.push("Please enter number of questions");
      }
    }

    setErrorsArr(errors);

    return bool;
  };

  const getValueForAttemptDD = () => {
    if (allowAttempts == 0) {
      return "NO";
    } else if (allowAttempts == 2) {
      return "MANY";
    } else if (allowAttempts == 1) {
      return numberOfAttempts;
    }
  };

  const modalUi = () => {
    return (
      <div className="createTriviaPopupContainer">
        {/* Basic config UI */}
        <div className="createTriviaPopupContainerUi1">
          {isMessaging && (
            <div className="my-3 message-type-section">
              <Label className="message-type-heading">Message type</Label>
              <div className="message-type-toggle">
                <button
                  type="button"
                  className={`message-type-option ${isOneWay ? "active" : ""}`}
                  onClick={() => setIsOneWay(true)}
                >
                  <TbMessageOff size={18} /> One-way
                </button>
                <button
                  type="button"
                  className={`message-type-option ${!isOneWay ? "active" : ""}`}
                  onClick={() => setIsOneWay(false)}
                >
                  <FiMessageSquare size={18} /> Two-way
                </button>
              </div>
              <div className="message-type-info">
                <BiInfoCircle size={20} />
                <div>
                  <div className="message-type-info-title">
                    {isOneWay ? "One-way message" : "Two-way message"}
                  </div>
                  <div className="message-type-info-desc">
                    {isOneWay
                      ? "Recipients can read your message but cannot reply. Use this for announcements, newsletters, or broadcast updates where no feedback is needed."
                      : "Recipients can read your message and reply directly. Use this for conversations, support requests, or when you need to collect responses."}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="my-3">
            <Label className="bwai_label_caps">
              {isMessaging ? "Message title" : "Name"}
              {!isMessaging && (
                <span className="bwai_required_mark">*</span>
              )}
            </Label>
            <Input
              className="bwai_field"
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
                setIsTitleManuallyTyped(e.target.value.length > 0);
              }}
              value={formData.name}
              placeholder="Please enter a name"
              // Locked while AI wording is generating: the response fills this
              // field, and `isTitleManuallyTyped` is captured when Generate is
              // clicked — so a title typed mid-request would be read as absent
              // and overwritten. Only applies to the messaging AI path; for
              // surveys `isGeneratingWording` is never true.
              disabled={isGeneratingWording}
            />
          </div>

          {isMessaging && (
            <div className="my-3">
              <Label className="bwai_label_caps">
                {BWAI_MSG_START_LABEL}
              </Label>
              <div className="bwai_msg_modes" role="group">
                {MESSAGE_MODES.map((mode) => {
                  const ModeIcon = mode.Icon;
                  const isActive = messageMode === mode.key;
                  return (
                    <div
                      key={mode.key}
                      className={`bwai_msg_mode${isActive ? " is-active" : ""}`}
                      role="button"
                      tabIndex={0}
                      aria-pressed={isActive}
                      onClick={() => switchMessageMode(mode.key)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          // Space would otherwise scroll the modal body.
                          e.preventDefault();
                          switchMessageMode(mode.key);
                        }
                      }}
                    >
                      <ModeIcon className="bwai_msg_mode_icon" />
                      <span className="bwai_msg_mode_body">
                        <span className="bwai_msg_mode_label">
                          {mode.label}
                        </span>
                        {mode.badge && (
                          <span className="bwai_msg_mode_badge">
                            {mode.badge}
                          </span>
                        )}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {isMessaging && messageMode === "AI" && (
            <div className="my-3 bwai_ai_panel">
              <div className="bwai_ai_panel_head">
                <HiOutlineSparkles className="bwai_ai_panel_icon" />
                <span className="bwai_ai_panel_title">{BWAI_MSG_AI_TITLE}</span>
              </div>
              <p className="bwai_ai_panel_desc">{BWAI_MSG_AI_DESC}</p>

              <div className="bwai_label_row">
                <Label className="bwai_label_caps mb-0">
                  {BWAI_MSG_AI_TITLE}
                </Label>
                <span className="bwai_counter">
                  {aiWordingPrompt.trim().length}/1000 (min 40)
                </span>
              </div>
              <textarea
                value={aiWordingPrompt}
                onChange={(e) => {
                  const val = e.target.value;
                  setAiWordingPrompt(val.slice(0, 1000));
                }}
                rows={4}
                className="w-100 bwai_textarea ai-wording-textarea"
                placeholder="Describe the message you need. For example: Let everyone know the office is closed on Monday for the public holiday, and remind them to submit timesheets before they leave on Friday."
                maxLength={1000}
              />
              <div className="bwai_ai_generate_row">
                <Button
                  size="sm"
                  className="bwai_btn_black"
                  disabled={
                    isGeneratingWording || aiWordingPrompt.trim().length < 40
                  }
                  onClick={generateWordingForMessage}
                >
                  <HiOutlineSparkles className="mr-2" />
                  {/* Once a draft exists the same button regenerates it, so it
                      names that instead of promising a first draft. */}
                  {isGeneratingWording
                    ? BWAI_MSG_AI_GENERATING
                    : hasGeneratedMessage
                    ? BWAI_MSG_AI_UPDATE
                    : BWAI_MSG_AI_GENERATE}
                </Button>
                <span className="bwai_ai_generate_hint">
                  {BWAI_MSG_AI_DRAFT_HINT}
                </span>
              </div>
            </div>
          )}

          {/* Once a sample is picked the grid collapses to this bar, so the
              Message Content box below it is reachable without scrolling. */}
          {isMessaging &&
            messageMode === "SAMPLE" &&
            selectedSampleTitle &&
            !isChoosingSample && (
              <div className="my-3 bwai_sample_selected">
                <span className="bwai_sample_selected_text">
                  <strong>{BWAI_MSG_SAMPLE_SELECTED}</strong>{" "}
                  {selectedSampleTitle}
                </span>
                <Button
                  size="sm"
                  className="bwai_btn_outline"
                  onClick={() => setIsChoosingSample(true)}
                >
                  {BWAI_MSG_SAMPLE_CHOOSE_ANOTHER}
                </Button>
              </div>
            )}

          {isMessaging &&
            messageMode === "SAMPLE" &&
            (!selectedSampleTitle || isChoosingSample) && (
              <div className="my-3">
                <div className="bwai_sample_head_row">
                  <span className="bwai_sample_heading">
                    {BWAI_MSG_SAMPLE_HEADING}
                  </span>
                  {/* Only offered when there is a prior choice to return to. */}
                  {selectedSampleTitle && (
                    <span
                      className="bwai_sample_cancel"
                      role="button"
                      tabIndex={0}
                      onClick={() => setIsChoosingSample(false)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          setIsChoosingSample(false);
                        }
                      }}
                    >
                      {BWAI_PICKER_CANCEL}
                    </span>
                  )}
                </div>
                <BwaiPromptList
                  items={SAMPLE_MESSAGING}
                  className="bwai_prompt_list--message bwai_prompt_list--grid"
                  actionLabel={BWAI_SAMPLE_MESSAGE_ACTION}
                  selectedTitle={selectedSampleTitle}
                  onSelect={(prompt) => {
                    // Ignored while AI wording is generating: the in-flight
                    // response overwrites messagingSubject unconditionally.
                    if (isGeneratingWording) {
                      return;
                    }
                    setMessagingSubject(prompt.description);
                    setMessagingTitle(prompt.title);
                    setSelectedSampleTitle(prompt.title);
                    setIsChoosingSample(false);
                    if (!isTitleManuallyTyped) {
                      setFormData({ ...formData, name: prompt.title });
                    }
                  }}
                />
              </div>
            )}

          {/* Above the content gate on purpose: the language applies to whatever
              the admin ends up writing, so it must not appear only afterwards. */}
          {isMessaging && showLanguageFeature && (
            <div className="my-3">
              <Label className="bwai_label_caps">
                {CREATE_LANGUAGE_SELECT_LABEL}{" "}
                <OoPopover
                  target="create_language_auto_detect"
                  css_class="create-language-tip"
                  headerText={CREATE_LANGUAGE_AUTO_DETECT_LABEL}
                  bodyText={CREATE_LANGUAGE_AUTO_DETECT_TOOLTIP}
                />
              </Label>
              <Select
                options={CREATE_LANGUAGE_OPTIONS_LIST}
                value={targetLanguage}
                onChange={(e) => {
                  if (e) {
                    setTargetLanguage(e.value);
                  } else {
                    setTargetLanguage(LANGUAGE_UNSET_VALUE);
                  }
                }}
                placeholder={DUPLICATE_LANGUAGE_PLACEHOLDER}
                searchable={true}
                clearable={false}
              />
            </div>
          )}
          {isMessaging && showMessageContent && (
            <div className="my-3">
              {/* The counter sits OUTSIDE the <Label> because `bwai_label_caps`
                  uppercases its contents, which would render "(MESSAGE CONTENT)". */}
              <div className="bwai_label_row">
                <Label className="bwai_label_caps mb-0">
                  {BWAI_MSG_CONTENT_LABEL}
                  <span className="bwai_required_mark">*</span>
                </Label>
                <span className="bwai_content_meta">
                  {/* Marks where this text came from, so an edited draft is
                      still recognisable as AI output rather than typed. */}
                  {messageMode === "AI" && hasGeneratedMessage && (
                    <span className="bwai_ai_badge">{BWAI_MSG_AI_BADGE}</span>
                  )}
                  <span className="bwai_counter">
                    {messagingSubject.length}/1500
                  </span>
                </span>
              </div>
              <textarea
                value={messagingSubject}
                onChange={(e) => {
                  if (e.target.value.length <= 1500) {
                    setMessagingSubject(e.target.value);
                  }
                }}
                rows={6}
                className="w-100 bwai_textarea"
                // Locked while AI wording is generating: the response overwrites
                // this value, so anything typed meanwhile is silently replaced.
                disabled={isGeneratingWording}
                placeholder={MESSAGING_CONTENT_PLACEHOLDER}
                maxLength={1500}
              />
              {/* Only where the text was produced for the user. In "Write it
                  myself" there is nothing to review — they just typed it. */}
              {messageMode !== "WRITE" && (
                <span className="bwai_content_hint">
                  {BWAI_MSG_CONTENT_HINT}
                </span>
              )}
            </div>
          )}

          {isMessaging && (
            <MessageAttachmentPicker
              attachment={messageAttachment && messageAttachment.attachment}
              onChange={setMessageAttachment}
              onUploadingChange={setIsUploadingAttachment}
            />
          )}

          {/* 
          {isMessaging && (
            <ShareHandlingForMessagingTrivvys
              setSmsUsers={setSmsUsers}
              user={user}
              currentFilters={currentFilters}
              setCurrentFilters={setCurrentFilters}
              setDeletedIds={setDeletedIds}
              deletedIds={deletedIds}
            />
          )} */}

          {isMessaging && (
            <div className="my-3 bwai_notify_row">
              <CheckBox
                checked={notifyAdminWhenUserRepliesToMessages}
                onChange={(e) => {
                  setNotifyAdminWhenUserRepliesToMessages(e.target.checked);
                }}
              />
              <Label className="mb-0 ml-2">
                Notify me when users respond.
                {/* Notify me when users respond to text messages */}
              </Label>
            </div>
          )}

          {/* Privacy is rendered inside the messaging card below, paired with
              the scheduled date, so the two short controls share one row the
              way Questions and Privacy do on the "Built with AI" screen. */}

          {!isMessaging ? (
            <div>
              {/* Questions + end date pair into one card, the same two-up the
                  "Built with AI" screen uses. The tip drops its filled Alert
                  for the muted inline line the design system uses elsewhere. */}
              <div className="my-3 bwai_card">
                <div className="bwai_two_up_row">
                  <div className="bwai_two_up_col">
                    <Label className="bwai_label_caps">
                      Number of Questions
                      <span className="bwai_required_mark">*</span>
                    </Label>
                    <Select
                      value={formData.questionsCount}
                      onChange={(e) => {
                        setFormData({ ...formData, questionsCount: e.value });
                      }}
                      options={questionOptions}
                      // Shortened: at half width the old "Select number of
                      // questions..." truncated to "Select number of questi...".
                      // The label above already names the field.
                      placeholder="Select..."
                    />
                  </div>

                  {/* Other options ui */}
                  <div className="bwai_two_up_col createTriviaPopupContainerUi3">
                    <Label className="bwai_label_caps">Select End Date</Label>
                    <div style={{ maxHeight: "400px" }}>
                      <ReactDatePicker
                        autoComplete="off"
                        id="actionDueDate"
                        minDate={moment().toDate()}
                        placeholderText="Enter date: MM/DD/YYYY"
                        className="form-control filter-action-date-input bwai_datepicker"
                        selected={trivvyEndDate}
                        onChange={(v) => {
                          if (v && v != null && v != undefined) {
                            const date = moment(v)
                              .endOf("day")
                              .local();
                            setTrivvyEndDate(date);
                          }
                        }}
                        showYearDropdown
                      />
                    </div>
                  </div>
                </div>

                <div className="bwai_helper_row">
                  <span className="bwai_tip">
                    Tip: Keep surveys to 5 questions or fewer for best results.
                    You can always add more in the Edit phase.
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="my-3 bwai_card">
                <div className="bwai_two_up_row">
                  <div className="bwai_two_up_col">
                    <Label className="bwai_label_caps">Privacy</Label>
                    <VisibilitySelect
                      value={visibility}
                      onChange={setVisibility}
                    />
                  </div>
                  <div className="bwai_two_up_col">
                {isEnterprisePlan ? (
                  <React.Fragment>
                    <Label className="bwai_label_caps">Scheduled Date</Label>
                    <div>
                      <ReactDatePicker
                        autoComplete="off"
                        dateFormat="MM/DD/YYYY 𝖺𝗍 h:mm a"
                        id="actionDueDate"
                        placeholderText="Enter date: MM/DD/YYYY"
                        className="form-control filter-action-date-input bwai_datepicker"
                        minDate={new Date()}
                        minTime={
                          scheduledDate
                            ? moment().isSame(moment(scheduledDate), "day")
                              ? moment()
                              : moment().startOf("day")
                            : moment()
                        }
                        maxTime={moment().endOf("day")}
                        selected={
                          typeof scheduledDate == "string"
                            ? moment(scheduledDate)
                            : scheduledDate
                        }
                        onChange={(v) => {
                          if (v) {
                            const date = moment(v);

                            if (
                              moment()
                                .startOf("day")
                                .isSame(date, "hour")
                            ) {
                              // Today @ midnight selected: bump to the next full hour (TBV-624: 00 min, 00 sec)
                              setScheduledDate(
                                moment()
                                  .add(1, "hour")
                                  .startOf("hour")
                              );
                            } else {
                              if (
                                moment(date)
                                  .startOf("day")
                                  .isSame(date, "hour")
                              ) {
                                // Future day @ midnight selected: default to 09:00:00
                                setScheduledDate(date.add(9, "hours").startOf("hour"));
                              } else {
                                // Snap to the nearest quarter-hour (TBV: quarter-hour scheduling)
                                setScheduledDate(snapToQuarterHour(date));
                              }
                            }
                          } else {
                            setScheduledDate(null);
                          }
                        }}
                        showYearDropdown
                        showTimeSelect
                        timeFormat="h:mm a"
                        timeIntervals={15}
                      />
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Label className="bwai_label_caps">Scheduled Date</Label>
                    <p
                      className="mb-0"
                      style={{
                        color: isEnterprisePlan ? "inherit" : "#6B7280",
                      }}
                    >
                      {" "}
                      Auto schedule your Trivvys <UpgradeTag text="Upgrade" />
                    </p>
                  </React.Fragment>
                )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  console.log("898989898");

  return (
    <div>
      {uiType == "POPUP" ? (
        <Modal isOpen={open} className="create-trivia-modal-component">
          <ModalHeader
            className="trivia_modal_header_bg"
            close={
              <BiX
                className="cursor-pointer"
                color="gray"
                size={30}
                onClick={() => onClose()}
              />
            }
          >
            Create New Trivvy
          </ModalHeader>
          <ModalBody
            className={`px-5 pt-2 pb-5 ${
              loading ? "wrapped-component-on-loading" : ""
            }`}
          >
            {modalUi()}

            {errorsArr && errorsArr.length ? (
              <Alert color="danger" className="my-2">
                <ul>
                  {errorsArr.map((x) => (
                    <li>{x}</li>
                  ))}
                </ul>
              </Alert>
            ) : (
              ""
            )}
          </ModalBody>

          <ModalFooter>
            {!loading ? (
              <Button
                color="success"
                className="mr-4 btn-success"
                disabled={isUploadingAttachment}
                onClick={() => {
                  if (isValidResponses()) {
                    setErrorsArr([]);
                    if (isMessaging) {
                      createSurvey();
                    } else {
                      createAndSendSMSSurvey();
                    }
                  }
                }}
              >
                {!isMessaging ? "Generate" : "Create Message"}{" "}
                <FaArrowRight className="ml-2" />{" "}
              </Button>
            ) : (
              <span> {isMessaging ? "Generating" : "Creating"}...</span>
            )}
          </ModalFooter>
        </Modal>
      ) : (
        <div>
          {modalUi()}

          {errorsArr && errorsArr.length ? (
            <Alert color="danger" className="my-2">
              <ul>
                {errorsArr.map((x) => (
                  <li>{x}</li>
                ))}
              </ul>
            </Alert>
          ) : (
            ""
          )}

          <ModalFooter className="justify-content-between bwai_footer">
            {onBack ? (
              <Button className="bwai_btn_outline" onClick={onBack}>
                Back
              </Button>
            ) : (
              ""
            )}
            {!loading ? (
              <Button
                className="bwai_btn_black"
                // Blocked while AI wording is in flight: the response writes into
                // messagingSubject, so this would save a body the admin never saw.
                disabled={isGeneratingWording || isUploadingAttachment}
                onClick={() => {
                  if (isValidResponses()) {
                    setErrorsArr([]);
                    if (isMessaging) {
                      console.log("hello here now 3");
                      createAndSendSMSSurvey();
                    } else {
                      console.log("hello here now 2");
                      createSurvey();
                    }
                  }
                }}
              >
                {!isMessaging ? "Generate" : "Create"}{" "}
                <FaArrowRight className="ml-2" />{" "}
              </Button>
            ) : (
              <span>{!isMessaging ? "Generating" : "Creating"}...</span>
            )}
          </ModalFooter>
        </div>
      )}
    </div>
  );
}

export default Loading(CreateTriviaPopup, axios);
